import { useRef, useCallback } from "react";
import toast from "react-hot-toast";

export const useAudioPlayback = () => {
  const isPlayingRef = useRef(false);

  /**
   * @type {(token: string, counter: string) => void}
   */
  const playAudio = useCallback((token, counter) => {
    if (isPlayingRef.current) {
      toast.error("Audio is already playing. Please wait for it to finish.");
      return;
    }

    const text = `Token Number ${token}, Please go to ${counter}`;
    const encodedText = encodeURIComponent(text);
    const audioUrl = `https://translate.google.com/translate_tts?ie=UTF-8&client=tw-ob&tl=en&q=${encodedText}`;

    const audio = new Audio(audioUrl);
    isPlayingRef.current = true;

    audio
      .play()
      .then(() => {
        audio.onended = () => {
          isPlayingRef.current = false;
        };
      })
      .catch((error) => {
        toast.error("Error playing the audio:", error);
        isPlayingRef.current = false;
      });
  }, []);

  return { playAudio };
};
